import React, {useEffect, useState} from 'react';
import {Link, useHistory} from "react-router-dom";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Collapse from "@mui/material/Collapse";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {Button, Modal} from "antd";

const AdminApplication = () => {
    let history = useHistory()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalRemove, setIsModalRemove] = useState(false);
    const [isModalOpenItem, setIsModalOpenItem] = useState(null);
    const [isModalOpenItemType, setIsModalOpenItemType] = useState("");
    const [data, setData] = useState([])
    const [selCol, setSelCol] = useState([]);
    const [sendData, setSendData] = useState({});
    const [type, setType] = useState(null)

    const getAll = () => {
        axios.get(API_PATH + "service/application/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setData(res?.data)
            })
    }
    const showModalDelete = (id, type) => {
        setIsModalRemove(true);
        setIsModalOpenItem(id)
        setType(type)

    };
    const saveApp = () => {
        axios.put(API_PATH + "service/application/" + isModalOpenItem + "/update", {
            "status": 2,
        } , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setIsModalRemove(false);
                getAll()
            })
    }
    const ignoreApp = () => {
        axios.put(API_PATH + "service/application/" + isModalOpenItem + "/update", {
            "status": 3,
            "note": sendData?.note
        } , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setIsModalRemove(false);
                getAll()
            })
    }

    useEffect(() => {
        getAll()
    }, []);
    return (
        <div className="profile-edit users">
            <div className="progress-link">
                <Link to="/global-admin/application"> <img src="/icon/Icon1.svg" alt="."/></Link>
                <img src="/icon/arrowleft.svg" alt="."/>
                <Link to="/global-admin/application"> <span>Заяфки</span></Link>
            </div>
            <div className="employees-header ">
                <div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="left-head">
                            <h6 className="font-family-medium">Заяфки</h6>
                            {/*<button onClick={importFc}>123123123</button>*/}
                        </div>

                    </div>
                </div>
            </div>

            <div className="emp-table">
                <TableContainer component={Paper}>
                    <Table sx={{minWidth: 650}} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className="table-head">Название компании</TableCell>
                                <TableCell className="table-head">Название услуги </TableCell>
                                <TableCell className="table-head"></TableCell>
                                {/*<TableCell className="table-head" >Интервал</TableCell>*/}
                                <TableCell className="table-head" align="right">Действие</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                data?.map((item, index) => (
                                    <>
                                        <TableRow
                                            sx={{'&:last-child td, &:last-child th': {border: 0}}}

                                            className="cursor-pointer"
                                        >
                                            <TableCell component="th" scope="row">
                                                    <span
                                                        className="t-name d-flex align-items-center font-family-medium">
                                                        {item?.company_name}</span>
                                            </TableCell>
                                            <TableCell className="twt"><span
                                                className="font-family-medium">{item?.service_title}</span></TableCell>
                                            <TableCell className="twt"><span
                                                className="font-family-medium"> </span></TableCell>
                                            {/*<TableCell className="twt" ><span className="font-family-medium">{item?.interval}</span></TableCell>*/}
                                            <TableCell className="twt" align="right">
                                                <div>
                                                    <button className="app-add-remove-btn mr-8"
                                                            onClick={() => showModalDelete(item?.id, "ignore")}
                                                    >
                                                        Игнорировать
                                                    </button>
                                                    <button className="app-add-active-btn"
                                                            onClick={() => showModalDelete(item?.id, "save")}
                                                    >
                                                        Применять
                                                    </button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                                                <Collapse in={selCol?.filter(item2 => item2 === index)?.length > 0}
                                                          timeout="auto" unmountOnExit>
                                                    {
                                                        item?.service_parts?.map(item3 => (
                                                            <p className="text-white mt-2 mb-2">
                                                                {item3?.name}
                                                            </p>
                                                        ))
                                                    }
                                                </Collapse>
                                            </TableCell>
                                        </TableRow>
                                    </>
                                ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <Modal title="Внимание!"
                   open={isModalRemove}
                   onCancel={() => setIsModalRemove(false)}
                   footer={[<Button key="submit" type="default" onClick={() => setIsModalRemove(false)}>
                       Отменить
                   </Button>,
                       type === "save" ?
                           <Button key="submit" type="primary" className="my-red-canc" onClick={saveApp}>
                               Сохранять
                           </Button>
                           : <Button key="submit" type="primary" className="my-red-canc" onClick={ignoreApp}>
                               Игнорировать
                           </Button>

                   ]

                   }
            >
                <div className="cam-add-modal">
                    {
                        type === 'save'
                            ?
                            <p className="mt-2 mb-2 text-white">Прием заявки</p>
                            :
                            <div className="inputs-box mt-3">
                                <label className="font-family-medium">Причина</label>
                                <input
                                    value={sendData?.title}
                                    onChange={(e) => setSendData({...sendData, note: e.target.value})}
                                    type="text"/>
                            </div>
                    }

                </div>
            </Modal>
        </div>

    );
};

export default AdminApplication;